import React, { useEffect } from 'react'
import { Paper } from '@material-ui/core'
import ActionBar from 'components/ActionBar'

import { useHistory, useLocation } from 'react-router-dom'
import ViewHeader from 'components/ViewHeader'
import { useDispatch, useSelector } from 'react-redux'
import ResourceNotFound from '../../../components/ResourceNotFound'
import Loading from '../../../components/Loading'
import { EditOutlined as EditIcon, DeleteOutlineOutlined as DeleteIcon } from '@material-ui/icons'
import { useConfirm } from 'material-ui-confirm'
import Tooltip from '@material-ui/core/Tooltip'
import BasicTable from 'components/BasicTable'
import getTableOptions from '../../../utils/getTableOptions'
import announcementSlice, {
  fetchAnnouncements,
  deleteAnnouncementById
} from '../../../store/announcements'
import { renderCol } from 'utils/renderColumns'
import { convertTimestampToLocalString } from 'utils/times'
import { AnnouncementStatus } from 'constants/index'
import RichTextRenderer from 'components/RichTextRenderer'

const AnnouncementListing = () => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const confirm = useConfirm()
  const { announcements, currentPage, pageSize, inProgress } = useSelector(
    (state) => state.announcements
  )

  const { conference } = useSelector((state) => state.conference)

  useEffect(() => {
    dispatch(fetchAnnouncements())
  }, [dispatch])

  const tableHead = [
    'Announcement Text',
    {
      name: 'Scheduled For',
      options: {
        customBodyRender: (value) =>
          value ? (
            <div style={{ minWidth: '130px' }}>
              {convertTimestampToLocalString(value, conference?.timezone, conference?.is24hrFormat)}
            </div>
          ) : (
            'N/A'
          )
      }
    },
    {
      name: 'Sent On',
      options: {
        customBodyRender: (value) =>
          value ? (
            <div style={{ minWidth: '130px' }}>
              {convertTimestampToLocalString(value, conference?.timezone, conference?.is24hrFormat)}
            </div>
          ) : (
            'N/A'
          )
      }
    },
    {
      name: 'Actions',
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value) => renderCol(value),
        customHeadLabelRender: (meta) => renderCol(meta.label)
      }
    }
  ]
  const formatTableData = (announcements) =>
    announcements.map((announcement) => {
      let sentOn
      if (announcement?.scheduledOn && announcement?.status === AnnouncementStatus.SENT) {
        sentOn = announcement?.scheduledOn
      } else if (announcement?.scheduledOn && announcement?.status !== AnnouncementStatus.SENT) {
        sentOn = ''
      } else {
        sentOn = announcement?.publishedOn
      }

      return [
        <RichTextRenderer htmlContent={announcement?.announcementText || ''} />,
        announcement?.scheduledOn,
        sentOn,
        <>
          <Tooltip title="Edit">
            <EditIcon
              color="action"
              style={{ cursor: 'pointer' }}
              onClick={() => history.push(`${location.pathname}/edit/${announcement.id}`)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <DeleteIcon
              color="action"
              style={{ marginLeft: 5, cursor: 'pointer' }}
              onClick={async () => {
                try {
                  await confirm({
                    title: 'Delete Announcement ',
                    description: 'Are you sure you want to delete this announcement ?'
                  })
                  dispatch(deleteAnnouncementById(announcement.id))
                } catch {
                  // do nothing
                }
              }}
            />
          </Tooltip>
        </>
      ]
    })

  const options = getTableOptions()

  return (
    <>
      <ViewHeader title="Announcements">
        {inProgress && <Loading />}
        <ActionBar
          actionText="New Announcement"
          onAction={() => history.push(`${location.pathname}/new`)}
          searchPlaceholder="Search Announcement"
        />
      </ViewHeader>

      {announcements && announcements.length ? (
        <Paper variant="outlined" style={{ marginTop: 20 }}>
          <BasicTable
            data={formatTableData(announcements)}
            columns={tableHead}
            options={{
              ...options,
              onChangePage: (page) => dispatch(announcementSlice.actions.setCurrentPage(page)),
              onChangeRowsPerPage: (size) => dispatch(announcementSlice.actions.setPageSize(size)),
              page: currentPage,
              rowsPerPage: pageSize
            }}
          />
        </Paper>
      ) : (
        !inProgress && <ResourceNotFound message="No announcement available" />
      )}
    </>
  )
}

export default AnnouncementListing
